import { useI18n } from "@core/i18n/i18n";
import { useStateParams } from "@core/routing/use-state-params";
import { useHistory } from "@core/routing/use-history";
import { InvitationPtNotInvitedError } from "@domain/healthcare-team/healthcare-team-errors";
import styled from "@emotion/styled";
import { Page } from "@ui/components/common/page";
import { PageHeader } from "@ui/components/common/page-header";
import { ToastContext } from "@ui/components/common/toast-provider";
import { DialogContext, ModalId } from "@ui/components/dialog/dialog-provider";
import { RoutesPath } from "@ui/navigation/routes";
import { AddPatientButton } from "@ui/pages/home/components/add-patient-button";
import { PatientTabs } from "@ui/pages/home/components/patient-tabs";
import { ValidateAccountCard } from "@ui/pages/home/components/validate-account-card";
import { useHealthcareTeamAcceptDialog } from "@ui/pages/home/hooks/use-healthcare-team-accept-dialog";
import { physioMeTabletBreakpoint } from "@ui/style";
import React, { useContext } from "react";
import { useOnceEffect } from "@core/hooks/use-once-effect";

export const HomePage = (): JSX.Element => {
	const { format } = useI18n();
	const { cleanHistory } = useHistory<RoutesPath.Home>();
	const dialogContext = useContext(DialogContext);
	const stateParams = useStateParams<RoutesPath.Home>();

	const { showToast } = useContext(ToastContext);

	useOnceEffect(
		() =>
			stateParams.openAddPatientModal &&
			dialogContext?.openModal(ModalId.AddPatient, {
				contentStyle: { overflowY: "visible" },
			}),
	);

	useHealthcareTeamAcceptDialog({
		onError: error => {
			if (error instanceof InvitationPtNotInvitedError) {
				showToast(
					format("home.healthcareTeam.errorToast.ptNotInvited.title"),
					format("home.healthcareTeam.errorToast.ptNotInvited.subtitle"),
					"error",
				);
				cleanHistory();
			}
		},
	});

	return (
		<StyledPage>
			<ValidateAccountCard showForPendingPt={true} />
			<PageHeader title={format("home.title")} primaryButton={<AddPatientButton />} />
			<Card className="p-card">
				<PatientTabs />
			</Card>
		</StyledPage>
	);
};

const StyledPage = styled(Page)`
	@media ${physioMeTabletBreakpoint} {
		margin: 0;
		padding: 0;
		width: 100%;
		max-width: unset;
	}
`;

const Card = styled.div`
	padding: 32px;
	width: 1200px;
	max-width: 100%;

	@media ${physioMeTabletBreakpoint} {
		padding: 0;
		flex-grow: 1;
		border-radius: 0;
	}
`;
